module.exports = __webpack_public_path__ + "static/img/007城市名片7.8ad1f5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/007城市名片7.jpg
// module id = 4F4k
// module chunks = 0